import { DateTime } from 'luxon';

export const MAX_TAGS = 20;
export const MAX_TASKS = 100;
export const MAX_VIEWS = 100;

export abstract class Constants {
    static readonly bankTabItems = 98;
    static readonly characterMaxLevel: number = 90;
    static readonly charactersPerAccount: number = 70;
    static readonly expansion: number = 11;
    static readonly lockoutDifficultyMultiplier = 1_000_000;
    static readonly maxRenown: number = 80;
    static readonly restedDuration: number = 10 * 24 * 60 * 60; // 10 days

    static readonly mythicPlusSeason: number = 18;

    static readonly defaultUnixTime = 946684800;
    static readonly defaultTime = DateTime.fromSeconds(Constants.defaultUnixTime);

    static readonly remixMythicPlusSeason: number = 1001;

    static readonly currencies = {
        catalyst: 3465, // Venomblight Manaflux [Mid S2]
        conquest: 1602,
        garrisonResources: 824,
        honor: 1792,
    };

    static readonly items = {
        petCage: 82800,
        trovehuntersBounty: 274374, // Midnight Season 2
    };

    static readonly reputations = {
        nazjatarFriends: [2377, 2389, 2376, 2388, 2375, 2390],

        artisansConsortium: 2544,
        loammNiffen: 2564,
        delveBrann: 2640,
        delveValeera: 2744,

        midnightAmani: 2696,
        midnightHarati: 2704,
        midnightSingulatity: 2699,
        midnightSilvermoon: 2710,
    };

    // item JSON -> itemBonusListGroups -> match upgradeTiers IDs
    static readonly seasonItemBonusListGroups = new Set<number>([
        // 607,
        // 608,
        // 609,
        // 610,
        // 611,
        // 612, // first set
        613,
        614,
        615,
        616,
        617,
        618, // second set
        // 619,
        // 626,
        // 627,
        // 628,
        // 629,
        // 630, // third set
    ]);

    static readonly upgradeTiers = {
        explorer: 970,
        adventurer: 971,
        veteran: 972,
        champion: 973,
        hero: 974,
        myth: 978,
    };

    static readonly icons = {
        alliance: 'achievement/13467', // Tides of Vengeance
        horde: 'achievement/13466', // Tides of Vengeance

        anniversary: 'item/71134', // Celebration Package
        chromieTime: 'spell/96794', // Time Warp
        enchant: 'spell/7411', // Enchanting
        gem: 'item/12361', // Blue Sapphire
        heirloom: 'item/122338', // Ancient Heirloom Armor Casing
        resting: 'spell/140430', // Passed Out
        torghast: 'spell/334746', // Access to Torghast
        upgrade: 'spell/331516', // Enhance Soulkeeper
        warMode: 'spell/304019', // Conflict and Strife
        weeklyAnima: 'spell/341209', // Overwhelming Anima
        weeklyShapingFate: 'item/186196', // Death's Advance War Chest
        weeklySouls: 'spell/225100', // Charging Station

        armorCloth: 'item/102289',
        armorLeather: 'item/102282',
        armorMail: 'item/102275',
        armorPlate: 'item/102268',
    };
}

export abstract class ItemLevels {
    static readonly Adventurer = {
        1: 266,
        2: 269,
        3: 272,
        4: 276,
        5: 279,
        6: 282,
    };
    static readonly Veteran = {
        1: 279,
        2: 282,
        3: 285,
        4: 289,
        5: 292,
        6: 295,
    };
    static readonly Champion = {
        1: 292,
        2: 295,
        3: 298,
        4: 302,
        5: 305,
        6: 308,
    };
    static readonly Hero = {
        1: 305,
        2: 308,
        3: 311,
        4: 315,
        5: 318,
        6: 321,
    };
    static readonly Myth = {
        1: 318,
        2: 321,
        3: 324,
        4: 328,
        5: 331,
        6: 334,
    };
}

export abstract class Strings {
    static readonly doUnlockQuests = 'Do unlock quests!';
}
